import { maxWholeDigits } from "@smartsuite/types";

export const isAllowedValue = (
  formattedValue: string,
  fieldParameters: { max_length?: number }
): boolean => {
  if (!formattedValue) return true;

  // Get only the digits from the formatted value (excluding decimal separator and negative sign)
  const digitsOnly = formattedValue.replace(/[^0-9]/g, "");

  // Calculate max allowed digits (default to maxWholeDigits if not specified)
  const maxDigits = fieldParameters.max_length ?? maxWholeDigits;

  return digitsOnly.length <= maxDigits;
};
